import styled from 'styled-components';

const MagnifyingGlass = styled.img`
  height: 22px;
  width: 22px;
  margin-right: 25px;
`;

export default MagnifyingGlass;
